import { useState, useEffect } from 'react';
import {
  ensureValidUri,
  getPPUrl,
  getPPAuthToken,
} from '@r-and-a-shared-ui/utils';

import { AUTH_TOKEN_KEY } from '../constants/playerPortals';

export type QueryResponse = {
  items: Array<any>;
  errorKey: string;
  httpStatusCode: number;
  successCode: string;
};

const useFetchPreRegistrationData = (
  preRegistrationAPI: any,
  managerContactId?: string | undefined,
  callbackUrl?: string | undefined,
) => {
  const [data, setData] = useState<QueryResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);

  const mutation = preRegistrationAPI?.['championship_players']?.useMutation();
  const authTokenMutation = preRegistrationAPI?.[AUTH_TOKEN_KEY]?.useMutation();

  const championshipPlayersAsync = mutation?.mutateAsync;

  const fetchPlayers = async () => {
    setLoading(true);

    const bearerToken = await getPPAuthToken(authTokenMutation.mutateAsync);

    const fullCallbackUrl = ensureValidUri(callbackUrl, getPPUrl());

    try {
      const res = await championshipPlayersAsync({
        callBackUrl: fullCallbackUrl,
        bearerToken,
        id: managerContactId,
      });

      setData(res);
    } catch (err: any) {
      console.error('Error fetching championship players data:', err);
    } finally {
      setLoading(false);
      setHasFetched(true);
    }
  };

  useEffect(() => {
    if (!callbackUrl) {
      setData(null);
      return;
    }

    fetchPlayers();
  }, [callbackUrl, managerContactId]);

  return { data, loading, hasFetched };
};

export default useFetchPreRegistrationData;
